import PageLayout from '@/components/feature/PageLayout';

export default function PolitiqueConfidentialite() {
  return (
    <PageLayout>
      <div className="bg-black py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <h1 className="font-heading text-5xl md:text-7xl text-white leading-none text-center mb-[4.55rem] md:mb-[6.5rem]">
            Politique de confidentialité
          </h1>

          <div className="flex flex-col gap-10 text-sm text-white/80 leading-relaxed">
            <section>
              <h2 className="font-heading text-lg text-white mb-3">Introduction</h2>
              <p>
                La présente politique de confidentialité a pour objectif d'informer les utilisateurs du site
                <strong className="text-white">romuald-designer.fr</strong> sur la manière dont leurs données
                personnelles sont collectées, traitées et protégées, conformément au Règlement Général sur
                la Protection des Données (RGPD).
              </p>
            </section>

            <section>
              <h2 className="font-heading text-lg text-white mb-3">Responsable du traitement</h2>
              <p>
                Le responsable du traitement des données est :
                <br />
                <strong className="text-white">Romuald Roudaut</strong>
                <br />
                14 rue des Artisans, 75011 Paris
                <br />
                Email : contact@romuald-designer.fr
              </p>
            </section>

            <section>
              <h2 className="font-heading text-lg text-white mb-3">Données collectées</h2>
              <p>
                Les données collectées via le formulaire de contact sont limitées au strict nécessaire :
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone (facultatif)</li>
                <li>Message / demande</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-lg text-white mb-3">Finalité du traitement</h2>
              <p>
                Les données sont collectées exclusivement dans le but de répondre aux demandes de contact,
                de fournir des devis ou d'établir un suivi commercial. Aucune donnée n'est utilisée à des
                fins publicitaires ou cédée à des tiers.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-lg text-white mb-3">Durée de conservation</h2>
              <p>
                Les données sont conservées pendant une durée de 3 ans à compter du dernier contact,
                conformément aux obligations légales en vigueur. Passé ce délai, elles sont supprimées.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-lg text-white mb-3">Vos droits</h2>
              <p>
                Conformément au RGPD, vous disposez des droits suivants :
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Droit d'accès à vos données</li>
                <li>Droit de rectification</li>
                <li>Droit à l'effacement (droit à l'oubli)</li>
                <li>Droit à la limitation du traitement</li>
                <li>Droit à la portabilité de vos données</li>
                <li>Droit d'opposition au traitement</li>
              </ul>
              <p className="mt-3">
                Pour exercer ces droits, contactez Romuald Roudaut à l'adresse
                <strong className="text-white">contact@romuald-designer.fr</strong>.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-lg text-white mb-3">Sécurité</h2>
              <p>
                Romuald Roudaut s'engage à mettre en œuvre les mesures techniques et organisationnelles
                nécessaires pour garantir la sécurité des données personnelles et prévenir leur accès
                non autorisé.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-lg text-white mb-3">Modification de la politique</h2>
              <p>
                Cette politique de confidentialité peut être modifiée à tout moment. Les utilisateurs
                sont invités à la consulter régulièrement pour prendre connaissance des éventuelles mises à jour.
              </p>
            </section>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}